import React from 'react';

const SubtractCircleBold = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    id="Subtract-Circle-Bold-Alternate--Streamline-Ultimate"
    height="26"
    width="26"
  >
    <desc>
      Subtract Circle Bold Alternate Streamline Icon: https://streamlinehq.com
    </desc>
    <g>
      <path
        d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm0 21a9 9 0 1 1 9 -9 9 9 0 0 1 -9 9Z"
        fill="#000000"
        strokeWidth="1"
      />
      <path
        d="M6.75 10.57h10.51s0.95 0 0.95 0.95v0.96s0 0.95 -0.95 0.95H6.75s-0.95 0 -0.95 -0.95v-0.96s0 -0.95 0.95 -0.95"
        fill="#000000"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export default SubtractCircleBold;
